import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiClock, FiBattery, FiTrendingDown, FiAlertCircle, FiRefreshCw } = FiIcons;

const ProblemSection = () => {
  const problems = [
    {
      icon: FiRefreshCw,
      title: "หมดไฟ...",
      description: "ทั้งที่อายุยังน้อย แต่พลังชีวิตกลับใกล้หมด"
    },
    {
      icon: FiAlertCircle,
      title: "กดดัน...",
      description: "ที่ต้อง Productive และประสบความสำเร็จตลอดเวลา"
    },
    {
      icon: FiTrendingDown,
      title: "หลงทาง...",
      description: "รู้สึกขาดการเชื่อมต่อกับตัวเองและโลกรอบข้าง"
    },
    {
      icon: FiBattery,
      title: "เหนื่อย...",
      description: "กับการวิ่งตามเทรนด์ในโซเชียลจนไม่มีเวลาได้พักจริงๆ"
    }
  ];

  return (
    <section className="py-20 px-4 bg-white">
      <div className="max-w-6xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-[#333333] mb-8" style={{ fontFamily: 'Kanit, sans-serif' }}>
            ติดอยู่ใน Loop ของ Hustle Culture จน Burnout ใช่ไหม?
          </h2>
          <p className="text-xl text-[#556B2F] mb-8" style={{ fontFamily: 'Sarabun, serif' }}>
            คุณรู้สึกเหมือนกำลังวิ่งบนลู่วิ่งที่ไม่เคยหยุดหรือเปล่า?
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8">
          {problems.map((problem, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, x: index % 2 === 0 ? -30 : 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="flex items-start space-x-4 p-6 rounded-xl bg-[#F5F5F5] hover:shadow-lg transition-all duration-300"
            >
              <div className="flex-shrink-0">
                <SafeIcon 
                  icon={problem.icon} 
                  className="text-3xl text-[#E07A5F]" 
                />
              </div>
              <div>
                <h3 className="text-xl font-bold text-[#333333] mb-2" style={{ fontFamily: 'Kanit, sans-serif' }}>
                  {problem.title}
                </h3>
                <p className="text-[#666666]" style={{ fontFamily: 'Sarabun, serif' }}>
                  {problem.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          viewport={{ once: true }}
          className="text-center mt-12"
        >
          <p className="text-lg text-[#556B2F] font-semibold" style={{ fontFamily: 'Sarabun, serif' }}>
            ถ้าคำตอบคือ "ใช่"… คุณไม่ได้เป็นคนเดียว และหนังสือเล่มนี้คือคำตอบสำหรับคุณ
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default ProblemSection;